import { Select, SelectProps } from '../inputs/select';

const months = Array.from({ length: 12 }, (_, i) => {
  const month = (i + 1).toString().padStart(2, '0');
  return { value: month, label: month };
});

export function MonthSelector(props: Omit<SelectProps, 'options'>) {
  return <Select options={months} {...props} />;
}
